import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { JsonDateParser } from "../../../../../react-core/Utils/JsonDateParser";
import { NotificationFilterDispatcher } from "./Variable";
import { ThreadQuery } from "../../../../../Wrap/Models/Domains/Threads/ThreadQuery";
import { ThreadType } from "../../../../../Wrap/Constants/Enums/Domain/ThreadType";
import { addDays, addMonths, addYears } from "../../../../../react-core/utils/date";
import { ClientNotificationFiltersModel } from "../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { NotificationDateRangeType } from "../../../../../Wrap/Constants/Enums/Client/NotificationFilter/NotificationDateRangeType";

export interface NotificationFilterStoreState {
    isLoading?: boolean;
    actionType: ActionType;
    pressedId?: number;
    data?: any[];
    adviserIds?: any[];
}

export class NotificationFilterStoreStatic extends BaseStore<NotificationFilterStoreState> {
    constructor() {
        super();
        this.subscribeToDispatcher(NotificationFilterDispatcher, (actionData) =>
            this.onNotificationFilterStoreResponse(actionData)
        );
    }

    public getLastResult(): NotificationFilterStoreState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getPressedId() {
        return this.getState().pressedId;
    }

    public getAdviserIds() {
        return this.getState().adviserIds;
    }

    public getDefaultFilter(): ClientNotificationFiltersModel {
        return {
            NotificationId: null,
            EventCategoryId: null,
            ClientReference: null,
            IsRead: false,
            EventType: ThreadType.NotSpecified,
            DateRangeOption: NotificationDateRangeType.PastWeek,
            AdviserIds: [],
        };
    }

    public calculateFromDate = (selectedDateRange: NotificationDateRangeType): Date => {
        let fromDate = new Date();
        if (selectedDateRange == NotificationDateRangeType.PastWeek) {
            fromDate = addDays(fromDate, -7);
        } else if (selectedDateRange == NotificationDateRangeType.PastMonth) {
            fromDate = addMonths(fromDate, -1);
        } else if (selectedDateRange == NotificationDateRangeType.PastThreeMonths) {
            fromDate = addMonths(fromDate, -3);
        } else if (selectedDateRange == NotificationDateRangeType.PastSixMonths) {
            fromDate = addMonths(fromDate, -6);
        } else if (selectedDateRange == NotificationDateRangeType.PastYear) {
            fromDate = addYears(fromDate, -1);
        } else {
            //default
            selectedDateRange = NotificationDateRangeType.PastMonth;
            fromDate = addMonths(fromDate, -1);
        }
        fromDate = addDays(fromDate, 1);
        return fromDate;
    };

    public convertDashboardFilterToQuery(filter: ClientNotificationFiltersModel, curPage: number): ThreadQuery {
        const fromDate = this.calculateFromDate(filter.DateRangeOption);
        return {
            FromDate: JsonDateParser.toJsonDateNoOffset(fromDate),
            ToDate: JsonDateParser.toJsonDateNoOffset(new Date()),
            AdviserIds: filter.AdviserIds || [],
            ThreadType: filter?.EventType,
            CategoryId: filter?.EventCategoryId,
            ClientName: filter?.ClientName,
            CompanyCode: filter?.CompanyCode,
            CurrentPage: curPage,
            ResultsPerPage: 10,
            AlertDefinitionId: filter?.NotificationId,
            ClAccountId: filter?.ClientReference,
            IsRead: filter?.IsRead,
            IsFollowed: filter?.FollowUp,
            ThreadIds: [],
        };
    }

    public getFilterItemById(id: number) {
        if (CommonHelper.isNullOrEmpty(id)) {return this.getDefaultFilter();}
        const findObj = this.getState().data.find((ele) => ele.FilterId == id);
        return findObj;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): NotificationFilterStoreState {
        return { actionType: ActionType.Loading, data: null, pressedId: null };
    }

    private onNotificationFilterStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, pressedId: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType, adviserIds: actionData.payload });
                break;
        }
    }
}
